const namespace = "cashStrip";

export const HEADER = `${namespace}.header`;
export const TITLE = `${namespace}.title`;
